import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../core/classes/modal-types.enum';

@Component({
  templateUrl: './modal-lounge-images.component.html',
  styleUrls: ['./modal-lounge-images.component.scss'],
  standalone: false
})
export class ModalLoungeImagesComponent implements OnInit {
  photos: string[] = null;
  selected: string;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.selected = this.photos[0];
  }
}

LightningModalTypes.ModalLoungeImagesComponent.component = ModalLoungeImagesComponent;
